/**
 * @generated SignedSource<<f6331c7f52f2babc5f8e8940f64d4f19>>
 * @relayHash 620df065b7431ceffafcc0bd6a2477a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6f95b1f8b37927e14435ca4228c482bb4cdadc4c126c2be318566284e9a1395

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation$variables = {
  spaceId: string;
};
export type WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation$data = {
  readonly watchBlogs: {
    readonly space: {
      readonly currentUser: {
        readonly isWatchingBlogs: boolean;
      };
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchSpaceInput"
      }
    ],
    "concreteType": "WatchSpacePayload",
    "kind": "LinkedField",
    "name": "watchBlogs",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "620df065b7431ceffafcc0bd6a2477a8",
    "id": "e6f95b1f8b37927e14435ca4228c482bb4cdadc4c126c2be318566284e9a1395",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation($spaceId:ID!){watchBlogs(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatchingBlogs}}}}"
  }
};
})();

(node as any).hash = "55ef642597667d6c9b68e438922daf62";

export default node;
